import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import useSEO from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({ title: "Página no encontrada", description: "La página que buscas no existe." });
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gema-black text-center px-6">
      <p className="font-heading font-black text-gema-red text-8xl md:text-9xl">404</p>
      <h1 className="heading-lg text-white mt-4">Página no encontrada</h1>
      <p className="text-white/50 mt-4 max-w-md">La página que buscas no existe o fue movida.</p>
      <Link to="/" className="btn-primary mt-8"><Home className="h-4 w-4" /> Volver al Inicio</Link>
    </div>
  );
}
